import { render, staticRenderFns } from "./GroupInvoiceBus.vue?vue&type=template&id=59f1055a"
import script from "./GroupInvoiceBus.vue?vue&type=script&lang=js"
export * from "./GroupInvoiceBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports